export enum LabelMode {
  ShowBoth,
  ShowIntoCell,
  ShowHeader,
  HideAll,
  Undefined,
}
